module.exports = __webpack_public_path__ + "static/img/logo.35f365b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/logo.png
// module id = ThK+
// module chunks = 1